import { GlobalState } from '../index';
import { IState } from '../reducers/createReviewData';

export const selectProductList = (state: GlobalState): IState['productList'] => state.createReviewData.productList;

export const selectServiceList = (state: GlobalState): IState['serviceList'] => state.createReviewData.serviceList;

export const selectCurrentService = (state: GlobalState): IState['service'] => state.createReviewData.service;

export const selectCurrentProduct = (state: GlobalState): IState['product'] => state.createReviewData.product;

export const selectCurrentReviewId = (state: GlobalState): IState['reviewId'] => state.createReviewData.reviewId;

export const selectCurrentOrganization = (state: GlobalState): IState['organization'] =>
  state.createReviewData.organization;
